'use client'

import { IconChatChatS } from 'icons/components/IconChatChatS'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import dynamic from 'next/dynamic'
import { useState } from 'react'

import { CHAT_ASSISTANT_ID } from '../../constants/constants'
import { dataTestIds } from '../../constants/dataTestIds'

import styles from './ChatAssistant.module.scss'

const CHAT_ASSISTANT_ICON_SIZE = 20

const ChatDialog = dynamic(
	() => import('../ChatDialog/ChatDialog').then((mod) => mod.ChatDialog),
	{
		ssr: false,
	}
)

export function ChatAssistant() {
	const { t } = useLabels()
	const [opened, setOpened] = useState(false)

	const handleClick = () => {
		setOpened(!opened)
	}

	return (
		<aside className={styles.chatAssistant}>
			{opened ? (
				<ChatDialog />
			) : (
				<button
					id={CHAT_ASSISTANT_ID}
					data-testid={dataTestIds['chatbot.button.open']}
					className={styles.chatAssistantButton}
					onClick={handleClick}
					type='button'
				>
					<IconChatChatS
						className={styles.icon}
						alt={t('accessibility.chatbot.icon')}
						height={CHAT_ASSISTANT_ICON_SIZE}
						width={CHAT_ASSISTANT_ICON_SIZE}
					/>
				</button>
			)}
		</aside>
	)
}
